<template>
  <el-dialog :visible.sync="visible" width="960px" :title="title" append-to-body :close-on-click-modal="false"
    custom-class="address-change-map-dialog" @opened="initMap" @closed="clearMap">
    <div class="summary">
      <div class="addr before">
        <span class="tag">改前</span>
        <span class="text">{{ beforeAddress || "暂无地址" }}</span>
      </div>
      <div class="addr after">
        <span class="tag">改后</span>
        <span class="text">{{ afterAddress || "暂无地址" }}</span>
      </div>
      <div class="distance">
        <span v-if="calculating">正在计算路网距离...</span>
        <span v-else-if="distance != null">
          路网距离 <b>{{ distance | mileFilter }}</b>
          <template v-if="duration">，预计 {{ duration | timeFilter }}</template>
        </span>
        <span v-else class="warn">{{ distanceTip || "无法计算路网距离" }}</span>
      </div>
    </div>
    <div id="addressChangeMap" class="map-container"></div>
  </el-dialog>
</template>

<script>
import { UnitUtil } from "@/util";

const beforeIcon = require("@/assets/image/mark_grey.png");
const afterIcon = require("@/assets/image/mark_b.png");

export default {
  name: "AddressChangeMap",
  data() {
    return {
      visible: false,
      addressIsStart: null,
      beforeAddress: "",
      afterAddress: "",
      beforeLng: null,
      beforeLat: null,
      afterLng: null,
      afterLat: null,
      distance: null,
      duration: null,
      calculating: false,
      distanceTip: "",
      map: null,
      driving: null
    };
  },
  computed: {
    sideText() {
      if (this.addressIsStart === true) {
        return "上车";
      }
      if (this.addressIsStart === false) {
        return "下车";
      }
      return "";
    },
    title() {
      return this.sideText ? `修改${this.sideText}地址` : "修改地址";
    }
  },
  methods: {
    open(row = {}) {
      this.addressIsStart = row.addressIsStart;
      this.beforeAddress = row.beforeAddress || "";
      this.afterAddress = row.afterAddress || "";
      this.beforeLng = this.toNumber(row.beforeLng);
      this.beforeLat = this.toNumber(row.beforeLat);
      this.afterLng = this.toNumber(row.afterLng);
      this.afterLat = this.toNumber(row.afterLat);
      this.distance = null;
      this.duration = null;
      this.calculating = false;
      this.distanceTip = "";
      this.visible = true;
    },
    toNumber(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const num = parseFloat(value);
      return Number.isFinite(num) ? num : null;
    },
    hasPoint(lng, lat) {
      return lng != null && lat != null;
    },
    initMap() {
      const container = document.getElementById("addressChangeMap");
      if (!container || typeof AMap === "undefined") {
        return;
      }
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
      const center = this.hasPoint(this.beforeLng, this.beforeLat)
        ? [this.beforeLng, this.beforeLat]
        : this.hasPoint(this.afterLng, this.afterLat)
          ? [this.afterLng, this.afterLat]
          : undefined;
      this.map = new AMap.Map("addressChangeMap", {
        resizeEnable: true,
        dragEnable: true,
        zoom: 14,
        center
      });
      this.drawMarkers();
      this.planRoute();
    },
    markerIcon(image) {
      return new AMap.Icon({
        size: new AMap.Size(28, 36),
        image,
        imageSize: new AMap.Size(28, 36)
      });
    },
    escapeHtml(text) {
      return String(text || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    drawMarkers() {
      const markers = [];
      const side = this.sideText ? `·${this.sideText}` : "";
      if (this.hasPoint(this.beforeLng, this.beforeLat)) {
        markers.push(
          new AMap.Marker({
            position: [this.beforeLng, this.beforeLat],
            icon: this.markerIcon(beforeIcon),
            offset: new AMap.Pixel(-14, -36),
            zIndex: 110,
            label: {
              direction: "top",
              content: `<div class="info addr-change-before">改前${side}<br/>${this.escapeHtml(this.beforeAddress)}</div>`
            }
          })
        );
      }
      if (this.hasPoint(this.afterLng, this.afterLat)) {
        markers.push(
          new AMap.Marker({
            position: [this.afterLng, this.afterLat],
            icon: this.markerIcon(afterIcon),
            offset: new AMap.Pixel(-14, -36),
            zIndex: 120,
            label: {
              direction: "right",
              content: `<div class="info addr-change-after">改后${side}<br/>${this.escapeHtml(this.afterAddress)}</div>`
            }
          })
        );
      }
      if (markers.length) {
        this.map.add(markers);
        this.map.setFitView(markers, false, [80, 80, 80, 80]);
      }
    },
    planRoute() {
      const hasBefore = this.hasPoint(this.beforeLng, this.beforeLat);
      const hasAfter = this.hasPoint(this.afterLng, this.afterLat);
      if (!hasBefore || !hasAfter) {
        this.distanceTip = "缺少坐标，无法计算路网距离";
        return;
      }
      const samePoint =
        Math.abs(this.beforeLng - this.afterLng) < 0.00001 &&
        Math.abs(this.beforeLat - this.afterLat) < 0.00001;
      if (samePoint) {
        this.distance = 0;
        this.duration = 0;
        return;
      }
      this.calculating = true;
      AMap.plugin("AMap.Driving", () => {
        if (!this.map) {
          this.calculating = false;
          return;
        }
        const driving = new AMap.Driving({
          map: this.map,
          policy: AMap.DrivingPolicy.LEAST_DISTANCE,
          hideMarkers: true,
          autoFitView: true,
          showTraffic: false
        });
        this.driving = driving;
        driving.search(
          [this.beforeLng, this.beforeLat],
          [this.afterLng, this.afterLat],
          (status, result) => {
            this.calculating = false;
            if (!this.visible || !this.map) {
              return;
            }
            const route = status === "complete" && result.routes && result.routes[0];
            if (!route) {
              this.distanceTip = "路网距离计算失败";
              return;
            }
            this.distance = route.distance || 0;
            this.duration = route.time || 0;
            this.markRouteDistance(route);
          }
        );
      });
    },
    markRouteDistance(route) {
      const path = [];
      (route.steps || []).forEach((step) => {
        (step.path || []).forEach((point) => path.push(point));
      });
      if (!path.length || !this.map) {
        return;
      }
      const mid = path[Math.floor(path.length / 2)];
      const mile = UnitUtil.mileFilter(route.distance || 0);
      const marker = new AMap.Marker({
        position: mid,
        anchor: "center",
        zIndex: 130,
        content: `<div class="addr-change-distance">路网距离 约${mile}</div>`
      });
      this.map.add(marker);
    },
    clearMap() {
      this.calculating = false;
      if (this.driving) {
        this.driving.clear();
        this.driving = null;
      }
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  margin-bottom: 12px;
  font-size: 13px;
  line-height: 20px;

  .addr {
    display: flex;
    align-items: flex-start;
    max-width: 100%;

    .tag {
      flex-shrink: 0;
      margin-right: 6px;
      padding: 0 6px;
      border-radius: 2px;
      color: #fff;
      line-height: 20px;
    }

    .text {
      color: #303133;
    }
  }

  .before .tag {
    background: #909399;
  }

  .after .tag {
    background: #409eff;
  }

  .distance {
    margin-left: auto;
    color: #303133;

    b {
      color: #e6a23c;
      font-size: 16px;
    }
  }

  .warn {
    color: #f56c6c;
  }
}

.map-container {
  width: 100%;
  height: 520px;
}
</style>

<style lang="less">
.address-change-map-dialog .el-dialog__body {
  padding: 12px 20px 20px;
}

.addr-change-distance {
  padding: 4px 8px;
  border-radius: 3px;
  background: rgba(230, 162, 60, 0.92);
  color: #fff;
  font-size: 13px;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}

.amap-marker-label .info.addr-change-before {
  background-color: rgba(96, 98, 102, 0.88);
}

.amap-marker-label .info.addr-change-after {
  background-color: rgba(64, 158, 255, 0.92);
}
</style>
